import { Order } from "@types";
import apiClient from "./api-client";

export type Orders = Order[]

export interface PaginatedOrdersResponse {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    content: Order[];
    total: number;
}

class OrdersApi {

    async getOrders(pageNumber = 0): Promise<PaginatedOrdersResponse> {

        const { data } = await apiClient.get(`/api/orders`, {
            params: {
                pageSize: 20,
                pageNumber,
            }
        }) as { data: PaginatedOrdersResponse };
        return data;
    }
}

const ordersApi = new OrdersApi();

export default ordersApi;
